/**
 * --------------------------------------------------------------------------
 * CoreUI (v3.4.0): index.umd.js
 * Licensed under MIT (https://uptblkpasuruan.com/license)
 * --------------------------------------------------------------------------
 */

import AsyncLoad from './src/async-load'
import Alert from './src/alert'
import Button from './src/button'
import Carousel from './src/carousel'
import ClassToggler from './src/class-toggler'
import Collapse from './src/collapse'
import Dropdown from './src/dropdown'
import Modal from './src/modal'
import Popover from './src/popover'
import Scrollspy from './src/scrollspy'
import Sidebar from './src/sidebar'
import Tab from './src/tab'
import Toast from './src/toast'
import Tooltip from './src/tooltip'
import './src/polyfills'

export default {
  AsyncLoad,
  Alert,
  Button,
  Carousel,
  ClassToggler,
  Collapse,
  Dropdown,
  Modal,
  Popover,
  Scrollspy,
  Sidebar,
  Tab,
  Toast,
  Tooltip
}
